/**
 * La couleur d'une matière, en touche légère (`DECISIONS.md`, 02/11) : la teinte à environ 7 % qu'un fond
 * prend. Une seule recette pour la chip de chapitre, la liste d'activités du live tuteur, la petite barre
 * d'un élève et la ligne d'objectif : la même alpha partout. Le liseré ne va qu'à **l'activité en cours** —
 * la barre d'un élève, la ligne où il est dans la liste —, la seule qu'il détache de ses voisines (Wajih,
 * round 4 : « on évite le liseré quand on peut », puis « le liseré […] était pertinent pour l'activité en
 * cours »). Ailleurs, la matière se dit par son picto, sa chip et sa teinte.
 */

/** L'alpha de la teinte, écrite dans la couleur (`#RRGGBBAA`) : 0x11, environ 7 %. */
const SUBJECT_TINT_ALPHA = "11"

/** Le liseré de l'activité en cours, à la couleur de sa matière. */
export const SUBJECT_RAIL_WIDTH = 3

/** La couleur d'une matière (un `#RRGGBB` du thème), teintée pour un fond. */
export function subjectTint(color: string): string {
    return `${color}${SUBJECT_TINT_ALPHA}`
}
